import styled from 'styled-components';

export const LinkWrapper = styled.div`
  margin-top: 16px;
`;
